import { ContentMedium } from '../types'

interface ContentMediaSelectedOptions {
  to?: Element | Document | null;  // Target pour dispatch (défaut: document)
  [key: string]: any;              // Extra args inclus dans event.detail
}

/**
 * Émet un événement content_medium:selected.
 * @param options.to - Cible du dispatch (défaut: document)
 */
export const emitContentMediaSelected = (
  contentMedium: ContentMedium,
  options: ContentMediaSelectedOptions = {}
) => {
  const { to, ...extraArgs } = options;
  const target = to || document;

  const customEvent = new CustomEvent("content_medium:selected", {
    detail: { contentMedium, ...extraArgs },
    bubbles: true
  });

  target.dispatchEvent(customEvent);
}

/**
 * Émet un événement content_media:batch_selected : les médias d'un lot d'upload, une fois
 * le lot terminé, dans l'ordre de la sélection. Les médias en échec n'y sont pas.
 * @param options.to - Cible du dispatch (défaut: document)
 */
export const emitContentMediaBatchSelected = (
  contentMedia: ContentMedium[],
  options: ContentMediaSelectedOptions = {}
) => {
  const { to, ...extraArgs } = options;
  const target = to || document;

  target.dispatchEvent(new CustomEvent("content_media:batch_selected", {
    detail: { contentMedia, ...extraArgs },
    bubbles: true
  }));
}

export const emitEditRendering = (parentId: number) => {
  const customEvent = new CustomEvent("content_medium_edit:rendering", {
    detail: { parentId },
    bubbles: true,
  });
  document.dispatchEvent(customEvent);
}

// Type pour le ContentMedium sérialisé par le backend (serialized_for_publisher)
export interface SerializedContentMedium {
  id: number;
  parent_id: number | null;
  replaces_id: number | null;
  kind: string;
  provisional_id: number;
  serialized_file: Record<string, any>;
  url: string | null;
  width: number | null;
  height: number | null;
  media_type: string;
  needs_edition: boolean;
  isOwn: boolean;
  "template?": boolean;
  "processing?": boolean;
  "editable?": boolean;
  [key: string]: any;
}

export const emitEditSaved = (contentMedium: SerializedContentMedium) => {
  const customEvent = new CustomEvent("content_medium_edit:saved", {
    detail: { contentMedium },
    bubbles: true,
  });
  document.dispatchEvent(customEvent);
}

export const closeFloatingMenu = (id: string) => {
  const customEvent = new CustomEvent("floating-menu:close", {
    detail: { id },
    bubbles: true,
  });
  document.dispatchEvent(customEvent);
}
